"use client";

import React from "react";
import { Spinner } from "react-bootstrap";

/**
 * Client component that shows a loader during redirect detection
 * This displays immediately when the page starts loading
 */
export default function BlogRedirectLoader() {
  return (
    <div
      className="loader-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <Spinner
        animation="border"
        variant="primary"
        style={{ width: "3rem", height: "3rem" }}
      />
      <p className="loading-text mt-3" style={{ color: "#333", fontSize: "18px", fontWeight: 500 }}>
        Loading post...
      </p>
    </div>
  );
}
